import { AxiosResponse } from "axios";
import CloudSaveModel from "./CloudSaveModel";
import CloudSaveReadModel from "./CloudSaveReadModel";
import CloudSaveService from "./CloudSaveService";

export default class CloudSaveHelper {
    static CloudSaveGet(prefix: string, gpxUrl: string): Promise<AxiosResponse<CloudSaveReadModel>> {
        return CloudSaveHelper.CloudSaveGetP(prefix === 'u', gpxUrl)
    }
    static CloudSaveGetP(isPublic: boolean, gpxUrl: string): Promise<AxiosResponse<CloudSaveReadModel>> {
        return isPublic ?
            CloudSaveService.CloudSaveGetPublic(gpxUrl) :
            CloudSaveService.CloudSaveGetPrivate(gpxUrl)
    }

}